import create from 'zustand'

export const useMobileToolbarStore = create((set) => ({
  searchOpen: false,
  filterOpen: false,
  toggleSearch: () => set((s) => ({ searchOpen: !s.searchOpen, filterOpen: false, pageActionOpen: false })),
  toggleFilter: () => set((s) => ({ filterOpen: !s.filterOpen, searchOpen: false, pageActionOpen: false })),
  closeAll: () => set({ searchOpen: false, filterOpen: false, pageActionOpen: false }),

  // pageAction: when set, the global mobile header renders an "Actions" pill
  // (with this menu) in place of the search/filter icons. Pages register on
  // mount via setPageAction and clear on unmount.
  pageAction: null,
  pageActionOpen: false,
  setPageAction: (action) => set({ pageAction: action }),
  clearPageAction: () => set({ pageAction: null, pageActionOpen: false }),
  togglePageActionMenu: () => set((s) => ({ pageActionOpen: !s.pageActionOpen, searchOpen: false, filterOpen: false }))
}))
